import { useSelector } from "react-redux";
import { State } from "../../../state/store";
import { DateTime } from "../../../domain/fundamental/DateTime";
import { useMemo } from "react";
import { InquiryListItem } from "../../../domain/inquiry/InquiryListItem";
import { UserName } from "../../../domain/user/UserName";
import { InquiryCategory } from "../../../domain/inquiry/InquiryCategory";
import { InquiryContent } from "../../../domain/inquiry/InquiryContent";
import { InquiryId } from "../../../domain/inquiry/InquiryId";

export const useInquiryList = (): ReturnType => {
    const { inquiries: responseJson, processing: processCount } = useSelector((state: State) => state.inquiry);

    const inquiries = useMemo(() => {
        return responseJson ? responseJson.map(inquiry => {
            let userName;
            if (inquiry.userName === null) {
                userName = null;
            } else {
                userName = UserName.fromString(inquiry.userName);
            }
            return InquiryListItem.from(
                InquiryId.fromString(inquiry.id),
                DateTime.fromString(inquiry.createdAt),
                userName,
                InquiryCategory.fromString(inquiry.category),
                inquiry.status,
                InquiryContent.fromString(inquiry.content)
            );
        }) : [];
    }, [responseJson]);

    const processing = processCount > 0;

    return { inquiries, processing };
};

type ReturnType = {
    inquiries: InquiryListItem[],
    processing: boolean
}
